/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "~/db/db";

const usePrazoPagamento = (formikRef, name = "prazoPagamentoId") => {
  const prazoPagamentoSelect = useSelect("prazoPagamento");
  const [prazoPagamento, setPrazoPagamento] = useState(0);

  const [prazoPagamentos, setPrazoPagamentos] = useState([]);

  useEffect(() => {
    const fetchPrazoPagamentos = async () => {
      const result = [];
      await db.prazoPagamento.filter((a) => a.ativo).each((item) => result.push(item));
      setPrazoPagamentos(result);
    };

    fetchPrazoPagamentos();
  }, []);

  const optionPrazosPagamento = useMemo(
    () => prepareForOptions(prazoPagamentos, ["codigo", "nome"], "id"),
    [prazoPagamentos]
  );

  function setSelectPrazoPagamento(id) {
    const prazo = optionPrazosPagamento.find((o) => o.value === id);
    if (prazo) {
      onChangePrazoPagamento(prazo);
    }
  }

  function onChangePrazoPagamento(e) {
    prazoPagamentoSelect.upDateValue(e.value);
    prazoPagamentoSelect.upDateDefaultValue(e || "");
    formikRef.current.setFieldValue(name, e.value);
    setTimeout(() => formikRef.current.setFieldTouched(name, true));
    setPrazoPagamento(e.value);
  }

  return {
    prazoPagamentos,
    onChangePrazoPagamento,
    prazoPagamento,
    prazoPagamentoSelect,
    optionPrazosPagamento,
    setSelectPrazoPagamento,
  };
};

export default usePrazoPagamento;
